import { useCallback } from "react"

import { useParams } from "react-router-dom"

import { useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { useExistingRoadwork } from "../../hooks/queries/useNetworkRoadworkLayer"

export const RoadworkValidator = (props) => {
    const { children } = props

    const { road, roadworkUuid } = useParams()
    const navigate = useNavigateWithSearchParams()

    const onBack = useCallback(() => {
        navigate(`../${road}`)
    }, [navigate, road])

    const existingRoadwork = useExistingRoadwork(roadworkUuid, road, onBack)

    if (!existingRoadwork) {
        return null
    }

    return children
}